import { takeLatest } from 'redux-saga/effects';
import {
  getJobRoleOfferListSuccess, getJobRoleOfferListFail,
  getJobRoleOfferDetailsSuccess, getJobRoleOfferDetailsFail,
} from './jobRoleOfferState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recruitment/job-role-offers');
const redirectData = {route:'/console/job-role-offers', mode: 'list', recordId:0 };
const modelName = 'JobRoleOffer';
const modelId = 'jof_id';

function* getJobRoleOfferList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getJobRoleOfferListSuccess, 
		getJobRoleOfferListFail, null, null, LOADING_MSG);
}

function* getJobRoleOfferDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getJobRoleOfferDetailsSuccess, 
		getJobRoleOfferDetailsFail, null, null, LOADING_MSG);		
}

function* doJobRoleOfferCreate(data){
	const { no_redirect } = data.payload;
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getJobRoleOfferDetailsSuccess, 
		getJobRoleOfferDetailsFail,
		createRecordSuccess(modelName),
		no_redirect == true ? null : redirectData, 
		SAVING_MSG);
}

function* doJobRoleOfferUpdate(data){
	const { no_redirect } = data.payload;
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getJobRoleOfferDetailsSuccess, 
		getJobRoleOfferDetailsFail,
		updateRecordSuccess(modelName),
		no_redirect == true ? null : redirectData, 
		UPDATING_MSG);	
}

function* doJobRoleOfferDelete(data){
	const { no_redirect } = data.payload;
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getJobRoleOfferDetailsSuccess, 
		getJobRoleOfferDetailsFail,
		deleteRecordSuccess(modelName),
		no_redirect == true ? null : {...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getApplicantJobRoleOffer(data){
	console.log(data.payload);
	yield doCrudCall(
		() => crudService.doGetRequest(`applicant/${data.payload.id}`), 
		getJobRoleOfferDetailsSuccess, 
		getJobRoleOfferDetailsFail, null, null, LOADING_MSG);		
}

function* jobRoleOfferSaga() {
  yield takeLatest('jobRoleOffer/getJobRoleOfferList', getJobRoleOfferList);
  yield takeLatest('jobRoleOffer/getJobRoleOfferDetails', getJobRoleOfferDetails);
  yield takeLatest('jobRoleOffer/doJobRoleOfferCreate', doJobRoleOfferCreate);
  yield takeLatest('jobRoleOffer/doJobRoleOfferUpdate', doJobRoleOfferUpdate);
  yield takeLatest('jobRoleOffer/doJobRoleOfferDelete', doJobRoleOfferDelete); 
  yield takeLatest('jobRoleOffer/getApplicantJobRoleOffer', getApplicantJobRoleOffer); 
   
}

export default jobRoleOfferSaga;
